<template lang="pug">
div.registration-flyout(v-if="isLoaded" :class="isLoading ? 'registration-flyout--loading' : ''")
  span.registration-flyout__lock
    i.fas.fa-lock-open-alt(v-if="isAuthenticated && isAccountExist && !isOptionalQuestions")
    i.fas.fa-lock-alt(v-else)
  div.registration-flyout__left
    a.registration-flyout__logo(href="/")
      img(src='/img/logo-light.svg' alt="OCC Logo")
    button.registration-flyout__close(@click="closeFlyout()")
      i.fas.fa-times
      span.registration-flyout__close-text Close
  div.registration-flyout__right
    Loader(v-if="isLoading")
    PageLogin(v-if="!isAuthenticated && !isResetPassword && isAccountExist")
    PageResetPassword(v-if="isResetPassword")
    PageRegistration(v-if="!isAccountExist")
    PageOptional(v-if="isOptionalQuestions && !optionalQuestionsDismissed")
    PageDashboard(v-if="isAccountExist && !isOptionalQuestions && isAuthenticated")
</template>

<script>
import { mapGetters, mapMutations, mapActions } from "vuex";
import Loader from "./transitions/Loader.vue";
import PageLogin from "./components/PageLogin.vue";
import PageResetPassword from "./components/PageResetPassword.vue";
import PageOptional from "./components/PageOptional.vue";
import PageRegistration from "./components/PageRegistration.vue";
import PageDashboard from "./components/PageDashboard.vue";
export default {
  name: "FlyoutRegistration",
  components: {
    Loader,
    PageLogin,
    PageResetPassword,
    PageOptional,
    PageRegistration,
    PageDashboard
  },
  data() {
    return {
      isLoggedIn: this.$parent.loggedIn,
      startRegistration: this.$parent.registration
    };
  },
  computed: {
		...mapGetters(["isLoaded", "isLoading", "isResetPassword", "isAuthenticated", "isAccountExist", "isOptionalQuestions", "isOptionalEmail", "isDisabled", "isLoading", "isRedirect", "optionalQuestionsDismissed"])
	},
	methods: {
		...mapMutations(["setRegistrationPage", "setDisabled", "setError","setData", "setLoaded", "setLoading", "setAccountExist", "setAuthenticated", "setRedirect", "setStateValue"]),
		...mapActions(["getData","getAccountInfo","getAccountCookies"]),
    closeFlyout() {
      if(this.isRedirect && this.isAuthenticated && this.isAccountExist) {
        window.location.replace(this.isRedirect)
      } else if(this.isLoggedIn === "false" && this.isAuthenticated && this.isAccountExist) {
        window.location.replace(window.location.href)
      }
      this.$el.parentElement.classList.toggle('is-active')
      document.body.classList.remove('login-is-active')
    }
  },
  created() {
    if(this.startRegistration) {
      this.setRegistrationPage(true)
      this.setError(false)
      this.setDisabled(false)
      this.setRedirect(window.location.href)
    } else if(this.isLoggedIn === "true") {
      this.setAccountExist(true)
      this.setAuthenticated(true)
    } else {
      setTimeout(() => {
        this.setLoading(false)
      }, 500);
    }
		let optionalQuestionsDismissed = !!localStorage.getItem('optionalQuestionsDismissed');
		this.setStateValue(['optionalQuestionsDismissed', optionalQuestionsDismissed]);
  },
  mounted() {
    const ref = this;
    // Constructing a url for forbidden content pages
    if(window.location.search.length > 0) {
      const params = new URLSearchParams(window.location.search)
      if(params.has('ReturnUrl')) {
        let returnUrl = params.get('ReturnUrl')
        if(returnUrl.charAt( 0 ) === '/') {
          returnUrl = returnUrl.slice(1)
        }
        this.setRedirect(`${window.location.origin}/${returnUrl}`)
      }
    }
    
    if(this.startRegistration) {
      const loginAnchor = document.querySelector('.header-profile')
      loginAnchor.click()
    }

    function checkFocus() {
      requestAnimationFrame(checkFocus);

      if (ref.$el.parentElement.classList.contains('is-active')) {
        if (!ref.$el.contains(document.activeElement))
          document.querySelector('.registration-flyout__logo').focus();
      }
    }
    checkFocus();
  }
};
</script>


<style lang="scss">
:root {
    --registration-blue: #1d2946;
    --registration-light-gray: #b0b0b0;
    --registration-button-blue: #2f5aa1;
    --registration-button-teal: #00c7ab;
    --registration-button-dark-teal: #004f71;
    --registration-button-blue-hover: #1f6ab1;
    --registration-button-teal-hover: #14e3b6;
    --registration-button-dark-teal-hover: #105f81;
    --registration-gap-base: 20px;
    --registration-font-family: 'Gilroy-Regular', Arial, Helvetica, sans-serif;
    --registration-font-family-bold: 'Gilroy-Bold', Arial, Helvetica, sans-serif;
    --registration-font-family-serif: 'Roboto Slab',  Arial, Helvetica, sans-serif;
    --registration-font-family-icon: 'Font Awesome 5 Pro';
    --registration-input-size: 1rem;
}
.registration-flyout {
  background: var(--registration-blue);
  color: $white;
  font-family: var(--registration-font-family);
  
    display: flex;
    flex: 1 1 auto;
    flex-direction: row;
    flex-wrap: wrap;
    padding: 0 1rem 0 .55rem;
    &__disabled {
      pointer-events: none;
    }
  &__lock {
    flex: 0 0 100%;
    font-size: 2em;
    padding: 2rem 0 0 13%;
    max-height: 70px;
    @include mqdn(sm){
      padding-left: 22%;
    }
  }
  &__logo{
    display: block;
    text-align: center;
    margin-bottom: 2rem;
    img {
      max-width: 55px;
      // margin: 0 auto;
    }
    @include mq(lg) {
      // -8px works better on design
      // -7px works better on dev
      transform: translateX(-7px);
    }
  }
  &__left {
    flex-basis: 10%;
    margin-top: -3.5rem;
    @include mq(lg) {
      margin-top: -2.9375rem;
    }
    @include mqdn(sm){
      flex-basis: 15%;
    }
  }
  &__close {
    @include clean(button);
    color: $white;
    font-family: $fontFamilyHeadings;
    flex-direction: column;
    display: flex;
    // font-size: 1rem;
    font-size: 28px;
    margin: 0 0 0 10px;
    // transform: translate(-35px, 15%);
    span {
      writing-mode: tb-rl;
      transform: rotate(180deg);
    }
    i {
      margin-bottom:.5rem;
    }
    @include mqdn(sm){
      font-size: .75rem
    }
  }
  &__right {
    flex-basis: 90%;
    @include mqdn(sm){
      flex-basis: 85%;
    }
  }
  &__error {
    font-size: 0.85em;
    color: #fff;
    width: 100%;    
    > * {
      margin-bottom: 0;
    }
    p {
      display: flex;
      flex-basis: 100%;
      align-items: center;
      gap: 1rem;
      padding: 0.5rem;
      flex-wrap: wrap;
    }
    i {
      border-radius: 50%;
      background-color: #f00;
      display: flex;
      align-items: center;
      font-size: .8em;
      justify-content: center;
      width: 2em;
      height: 2em;
    }
  }
  &__error-wrapper {
    border: 1px solid #f00;
    margin-bottom: .75rem;
    width: 100%;
  }
  &__disabled-anim {
    color: transparent;
    &:before {
      content: '\f110';
      color: var(--registration-button-teal);
      display: inline-block;
      font-family: var(--registration-font-family-icon);
      font-size: 1em;
      animation: spinner 1s linear infinite;
    }
  }
}

.login-page-wrapper {
  display: none;
  position: absolute;
  max-width: 900px;
  width: 98vw;
  z-index: -1;
  &.is-active {
    display: block;
    z-index: 1000;
    height: 100vh;
    overflow-y: auto;
    background: var(--registration-blue);
  }
}
@keyframes spinner {
  0% {
    transform: rotate(0deg) scale(1);
  }
  50% {
    transform: rotate(180deg) scale(1.25);
  }
  100% { 
    transform: rotate(360deg) scale(1); 
  }
}
</style>